import { Fragment } from 'react';
import { CommentV2 } from './CommentV2';
import { CommentV2 as CommentV2Type } from '~/lib/discussions/types';

export function ChildrenV2({
  root,
  comments,
  mutateComment,
  moderator = false,
  isReview = false,
}: {
  root: CommentV2Type;
  comments: CommentV2Type[];
  mutateComment: () => void;
  moderator?: boolean;
  isReview?: boolean;
}) {
  return (
    <>
      {comments.map((comment) => (
        <Fragment key={comment.id}>
          <CommentV2
            href={comment.display_path}
            comment={comment}
            moderator={moderator}
            mutateComment={mutateComment}
            border
            className="mt-10"
            isReview={isReview}
          />
          {comment.children && comment.children.length > 0 && (
            <div className="pl-4 sm:pl-12">
              <ChildrenV2
                root={root}
                comments={comment.children}
                moderator={moderator}
                mutateComment={mutateComment}
                isReview={isReview}
              />
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
}
